var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebsiteYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Free Youtube Logo Icon - Free Download Logos Logo Icons _ IconScout-24 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.7685 6.65566C14.7989 5.77483 14.6063 4.9006 14.2085 4.11412C13.9386 3.79142 13.564 3.57364 13.15 3.49874C11.4377 3.34337 9.71836 3.27969 7.99927 3.30797C6.28643 3.27841 4.57324 3.34003 2.86696 3.49259C2.52962 3.55395 2.21743 3.71218 1.9685 3.94797C1.41465 4.45874 1.35311 5.33259 1.29157 6.07105C1.20229 7.39878 1.20229 8.73101 1.29157 10.0587C1.30938 10.4744 1.37126 10.8869 1.47619 11.2895C1.55039 11.6003 1.70051 11.8879 1.91311 12.1264C2.16374 12.3747 2.48319 12.5419 2.83003 12.6064C4.15675 12.7702 5.49355 12.8381 6.83003 12.8095C8.98388 12.8403 10.8731 12.8095 13.107 12.6372C13.4623 12.5767 13.7908 12.4092 14.0485 12.1572C14.2208 11.9848 14.3495 11.7739 14.4239 11.5418C14.644 10.8665 14.7521 10.1597 14.7439 9.44951C14.7685 9.10489 14.7685 7.02489 14.7685 6.65566ZM6.6085 9.81874V6.00951L10.2516 7.92336C9.23003 8.48951 7.88234 9.12951 6.6085 9.81874Z",
    fill: "#4B4AD5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteYoutube);
export default __webpack_public_path__ + "static/media/website-youtube.6649e7d5fcb47595dcfb6c4389e52dfb.svg";
export { ForwardRef as ReactComponent };